<template>
  <el-form :model="form" ref="formRef" label-width="100px" :label-position="getIsMobile?'top':'right'">
    <el-form-item label="备注">
      <div v-for="(remark, index) in form.child_content" :key="index" class="remark-item">
        <el-input type="textarea" v-model="remark.content" placeholder="请输入备注内容" />
        <el-button type="danger" @click="removeRemark(index)" class="remark-delete">删除</el-button>
      </div>
      <el-button @click="addRemark" type="primary">新增备注</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import { defineComponent, reactive,watch } from '@vue/composition-api'
import useRootSetting from '@/hooks/useRootSetting'
export default defineComponent({
  props: {
    data: {
      type: Array,
      default() {return []}
    }
  },
  setup(props,{ emit }) {
    const {getIsMobile} = useRootSetting()
    const form = reactive({
      child_content: [{content:''}]
    })
    const addRemark = () => {
      form.child_content.push({ content: '' });
    }
    const removeRemark = (index) => {
      form.child_content.splice(index, 1);
    }

    watch(()=>props.data,(val)=>{
      if(val){
        form.child_content = val
      }
    })
    // 定义一个清空数据的方法
    const clearTable = () => {
      form.child_content.forEach(row => {
        Object.keys(row).forEach(key => {
          row[key] = '' // 清空每一项的值
        })
      })
    }
    return {
      getIsMobile,
      form,
      clearTable,
      addRemark,
      removeRemark
    }
  }
})
</script>

<style scoped lang="scss">
.remark-item {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  .remark-delete {
    margin-left: 15px;
  }
}
</style>
